import styled from 'styled-components';
import { removeScrollbar } from '@/styles/helpers';

export const Box = styled.div`
  ${removeScrollbar()}

  display: flex;
  flex-direction: column;
  gap: 18px;
  width: 100%;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    flex-direction: row;
    gap: 12px;
    overflow-x: auto;
    overflow: visible;
    align-items: center;
  }
`;

export const Controls = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
  flex-shrink: 0;
  align-items: center;
  width: 100%;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    justify-content: flex-start;
    gap: 12px;
    flex: 1 1 auto;
    min-width: 0;
    width: auto;
  }
`;
